export const messages = {
  en: {
    examineStaffManage: {
      search: {
        title: 'Search Conditions',
        staffName: 'Please enter staff name',
        projectName: 'Please enter project name'
      },
      list: {
        title: 'Assessment Staff',
        add: 'Add'
      },
      table: {
        face: 'Face',
        staffId: 'Staff ID',
        staffName: 'Staff Name',
        post: 'Post',
        projects: 'Assessment Projects',
        operation: 'Operation'
      },
      delete: {
        title: 'Confirm Operation',
        confirm: 'Are you sure to delete this assessment staff?',
        success: 'Delete successfully',
        error: 'Delete failed'
      },
      fetchError: 'Failed to fetch assessment staff data'
    }
  },
  zh: {
    examineStaffManage: {
      search: {
        title: '查询条件',
        staffName: '请输入员工名称',
        projectName: '请输入考核项目'
      },
      list: {
        title: '考核人员',
        add: '添加'
      },
      table: {
        face: '人脸',
        staffId: '员工编号',
        staffName: '员工名称',
        post: '岗位',
        projects: '考核项目',
        operation: '操作'
      },
      delete: {
        title: '确认操作',
        confirm: '确定删除该考核人员吗？',
        success: '删除成功',
        error: '删除失败'
      },
      fetchError: '获取考核人员数据失败'
    }
  }
}